import { gql } from '@apollo/client'

export default gql`
  mutation createGroup($name: String!, $color: String!) {
    createGroup(name: $name, color: $color) {
      id
      name
      color
    }
  }
`
